import * as React from 'react'
import { connect } from 'react-redux'
import { Card } from '../../deal'
import { SearchHit } from '../types'
import { getBrandUrl } from '../../brand/utilities'
import EventType from '../../../models/eventType'
import { ApplicationState } from '../../../reducers'
import { currentEventSelector } from '../../../data/selectors'

export type Props = {
    hit: SearchHit
}

type FieldProps = {
    eventType?: EventType
}

type AllProps = FieldProps & Props

class LoadSearchResult extends React.Component<AllProps> {
    render() {
        const { hit, eventType } = this.props

        const brandUrl = hit.brandSlug === undefined ? undefined : getBrandUrl(hit.brandSlug)

        return (
            <div className='col-xs-12 col-sm-6 col-md-3 list-deal'>
                <Card
                    id={hit.objectID}
                    title={hit.title}
                    offer={hit.offer}
                    optional1={hit.details}
                    optional2={hit.redemptionInfo}
                    imageUrl={hit.image}
                    brandName={hit.brand}
                    brandUrl={brandUrl}
                    brandImageUrl={hit.brandLogo}
                    slug={hit.slug}
                    type={hit.type}
                    eventType={eventType}
                    hit={hit}
                />
            </div>
        )
    }
}

const mapStateToProps = (state: ApplicationState, ownProps: Props): FieldProps => {
    if (ownProps.hit === undefined) {
        return {}
    }
    const event = currentEventSelector(state)

    return {
        eventType: event && event.type ? event.type : undefined,
    }
}

const SearchResult = connect(mapStateToProps)(LoadSearchResult)
export { SearchResult }
